import React from 'react'

export default function Patients() { 
    return (
        <div className='page-admin my-4'>
            
            <div
                    style={{
                        background: "rgb(255, 255, 255)",
                        padding: "20px",
                        borderRadius: "13px",
                        minHeight: "548px",
                        padding: "40px"
                        
                    }}
                >

            <h4>Pacientes</h4>
            <hr />
            <table className="table tablet-patients">
                <thead className='table-dark'>
                    <tr>
                        <th scope="col">N°</th>
                        <th scope="col">Nombre completo</th>
                        <th scope="col">Edad</th>
                        <th scope="col">Sexo</th>
                        <th scope="col">Diagnostico</th>
                        <th scope="col">Fecha de ultima visita</th>
                        <th scope="col">Historial clinico</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">1</th>
                        <td>Mark</td>
                        <td>Otto</td>
                        <td>M</td>
                        <td>@mdo</td>
                        <td>17/02/2024</td>
                        <td>
                            <button className='btn btn-primary'>
                                Historial clinico
                                <img src="/assets/icons/new/link.png" alt="" />
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">2</th>
                        <td>Jacob</td>
                        <td>Thornton</td>
                        <td>M</td>
                        <td>@fat</td>
                        <td>17/02/2024</td>
                        <td>
                            <button className='btn btn-primary'>
                                Historial clinico
                                <img src="/assets/icons/new/link.png" alt="" />
                            </button>
                        </td>

                    </tr>
                    <tr>
                        <th scope="row">3</th>
                        <td colSpan={2}>Larry the Bird</td>
                        <td>M</td>
                        <td>@twitter</td>
                        <td>17/02/2024</td>
                        <td>
                            <button className='btn btn-primary'>
                                Historial clinico
                                <img src="/assets/icons/new/link.png" alt="" />
                            </button>
                        </td>

                    </tr>
                </tbody>
            </table>
            </div>

        </div>
    )
}
